import FlashResultsCounterBadge from "../../../others/courses/flash/FlashResultsCounterBadge";
import FlashResultsDetailedScoreItemText from "../../../texts/courses/flash/FlashResultsDetailedScoreItemText";

export default function FlashResultsDetailedScoreItem({isGoodScore, score, label, color}) {
    // Used in FlashResultsDetailedScores to display one type of answer
    // counter and associated label

    // BUILD
    return (
        <div className="flex items-center justify-start space-x-[12px] h-[40px]">
            <FlashResultsCounterBadge color={color}
                                      score={score} />
            <FlashResultsDetailedScoreItemText isGoodScore={isGoodScore}
                                               label={label} />
        </div>
    );
}